import { render, staticRenderFns } from "./variant-carousel.vue?vue&type=template&id=72e3239a&scoped=true&lang=pug&"
import script from "./variant-carousel.vue?vue&type=script&lang=coffee&"
export * from "./variant-carousel.vue?vue&type=script&lang=coffee&"
import style0 from "./variant-carousel.vue?vue&type=style&index=0&id=72e3239a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e3239a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PdpProductImageSlide: require('/opt/build/repo/nuxt-app/components/pages/pdp/product-image-slide.vue').default,SsrCarousel: require('/opt/build/repo/node_modules/vue-ssr-carousel/index.js').default,PdpThumbnailNavigation: require('/opt/build/repo/nuxt-app/components/pages/pdp/thumbnail-navigation.vue').default})
